import _ from 'lodash';

const P = {
  name: 'name',
  code: 'code',
  splitStr: '\n',
};

const bsAttentionFunc = {
  getKeyList: (data, key) => {
    return _.map(data, (item) => {
      return item[key];
    });
  },

  getSameCode_nameList: function (refData, allData) {
    const result = [];
    const refList = this.getKeyList(refData, P.code);
    if (Array.isArray(refList) && refList.length > 0) {
      _.forEach(allData, (item) => {
        const index = refList.indexOf(item[P.code]);
        if (index > -1) {
          result.push(refData[index][P.name]);
        }
      });
    }
    return result;
  },

  getNoSameCode_nameList: function (refData, allData) {
    const result = [];
    const refList = this.getKeyList(refData, P.code);
    if (Array.isArray(refList) && refList.length > 0) {
      _.forEach(allData, (item) => {
        if (!refList.includes(item[P.code])) {
          result.push(item[P.name]);
        }
      });
    }
    return result;
  },

  getSortNameStr: function (refData, allData) {
    const sameNameList = this.getSameCode_nameList(refData, allData);
    const noSameNameList = this.getNoSameCode_nameList(refData, allData);
    const orderList = _.orderBy([...sameNameList, ...noSameNameList], null, 'asc');
    return Array.isArray(orderList) ? orderList.join(P.splitStr) : '';
  },

  getNameList: function (refData) {
    return this.getKeyList(refData, P.name);
  },

  // getNoSameName_nameList: function (refData, strData) {
  //   const result = [];
  //   const strList = _.split(strData, P.splitStr);
  //   if (Array.isArray(strList)) {
  //     _.forEach(strData, (item) => {
  //       return refData.includes(item[P.name]);
  //     });
  //   }
  //   return _.orderBy(result, null, 'asc');
  // },
};

export { bsAttentionFunc };
